import {Navigate, useLocation} from "react-router-dom";

// Old `…/executions` links (bookmarks, emails) forward to `…/runs`, query string included.
const LegacyExecutionsRedirect = () => {
    const {pathname, search} = useLocation();
    return <Navigate to={`${pathname.replace(/\/executions(?=\/|$)/, '/runs')}${search}`} replace/>;
};

export default LegacyExecutionsRedirect;
